<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active"><router-link to="/admin">Dashboard</router-link></li>
        <li v-if="allGrinderReborerMenuActive"><router-link to="/allGrinderReborer">Grinder</router-link></li>

        <li class="active">
          <a href="#">Update GrinderReborer ( {{ this.register.MechanicId }} )</a>
        </li>
      </ol>
      <form @submit.prevent="handleAddUser" autocomplete="off">
        <div class="panel-body locationform">
          <div
            v-if="message"
            class="alert-danger alert visibility"
            role="alert"
          >
            {{ message }}
          </div>
          <div class="tab-content">
            <div class="col-md-12">
              <div class="tab-container tab-default">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#home1" data-toggle="tab">Grinder Profile</a>
                  </li>
                  <li><a href="#profile1" data-toggle="tab">KYC</a></li>
                  <li><a href="#bankTab" data-toggle="tab">Bank Details</a></li>
                  <li>
                    <a href="#termsConditions" data-toggle="tab"
                      >Terms & Conditions</a
                    >
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="home1">
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Shop Name *</label>
                          <input
                            v-model="register.ShopName"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="ShopName"
                          />
                          <span v-if="errors.has('ShopName')">
                            {{ errors.first('ShopName') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>User Code </label>
                          <h4>{{register.MechanicId}}</h4>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>First Name *</label>
                          <input
                            v-model="register.FirstName"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="firstName"
                          />
                          <span v-if="errors.has('firstName')">
                            {{ errors.first('firstName') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Middle Name</label>
                          <input
                            v-model="register.MiddleName"
                            type="text"
                            class="form-control"
                            name="MiddleName"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Last Name *</label>
                          <input
                            v-model="register.LastName"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="LastName"
                          />
                          <span v-if="errors.has('LastName')">
                            {{ errors.first('LastName') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Address line 1 *</label>
                          <input
                            v-model="register.AddressLine1"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="AddressLine1"
                          />
                          <span v-if="errors.has('AddressLine1')">
                            {{ errors.first('AddressLine1') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Address line 2</label>
                          <input
                            v-model="register.AddressLine2"
                            type="text"
                            class="form-control"
                            name="AddressLine2"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Area </label>
                          <input
                            v-model="register.Area"
                            type="text"
                            class="form-control"
                            name="Area"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Pin Code *</label>
                          <input
                            v-model="register.Zip"
                            v-validate="'required|digits:6'"
                            type="text"
                            class="form-control"
                            placeholder="Zip Code"
                            name="PinCode"
                            v-on:keyup="getCityState"
                          />
                          <span v-if="errors.has('PinCode')">
                            {{ errors.first('PinCode') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>City *</label>
                          <input
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            placeholder="City"
                            v-model="register.selectedCity"
                            name="City"
                          />
                          <span v-if="errors.has('City')">
                            {{ errors.first('City') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>State *</label>
                          <input
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            placeholder="State"
                            v-model="register.State"
                            name="State"
                          />
                          <span v-if="errors.has('State')">
                            {{ errors.first('State') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Country *</label>
                          <input
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            placeholder="Country"
                            v-model="register.Country"
                            name="Country"
                          />
                          <span v-if="errors.has('Country')">
                            {{ errors.first('Country') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div  class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Market Segment</label>

                          <v-select
                            v-model="register.MarketSegment"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsMarketSegment"
                            :selectOnTab=true
                          >
                          </v-select>
                        </div>
                      </div>
                      
                    </div>
                  </div>

                  <div class="tab-pane" id="profile1">
                    <div class="row">
                      <div class="col-sm-3">
                        <file-upload
                          :labelName="'Upload Photo *'"
                          @imageUploadData="ProfileImageData"
                        ></file-upload>
                        <span v-if="errors.has('photoProfile')">
                          {{ errors.first('photoProfile') }}
                        </span>
                      </div>
                      <div class="col-sm-1">
                        <div class="form-group" v-if="register.ProfilePictureUrl">
                        <a :href="register.ProfilePictureUrl" target="_blank">View photo</a>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Aadhar Card No</label>
                          <input
                            v-model="register.AadharCardNo"
                            type="text"
                            class="form-control"
                            name="AadharCardNo"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Driving License No</label>
                          <input
                            v-model="register.DrivingLicenseNo"
                            type="text"
                            class="form-control"
                            name="DrivingLicenseNo"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>PAN No</label>
                          <input
                            v-model="register.PANNo"
                            type="text"
                            class="form-control"
                            name="PANNo"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Contact Number *</label>
                          <input
                            v-model="register.Mobile"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="Mobile"
                          />
                          <span v-if="errors.has('Mobile')">
                            {{ errors.first('Mobile') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Alternate Contact Number</label>
                          <input
                            v-model="register.Mobile2"
                            type="text"
                            class="form-control"
                            name="Mobile2"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Email ID </label>
                          <input
                            v-model="register.Email"
                            type="text"
                            class="form-control"
                            name="Email"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Gender </label>
                          <div class="">
                            <label
                              ><input
                                v-model="register.Gender"
                                value="Male"
                                type="radio"
                              />
                              Male</label
                            >
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label
                              ><input
                                v-model="register.Gender"
                                value="Female"
                                type="radio"
                              />
                              Female
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Date of Birth </label>
                          <dobPicker
                            @selectedDate="DOBSelected"
                            :preSelectDob="register.DateOfBirth"
                          ></dobPicker>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Size of workshop *</label>

                          <v-select
                            v-model="register.SizeOfWorkshop"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsSizeOfWorkshop"
                            :selectOnTab=true
                          >
                          </v-select>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Service per month</label>
                          <v-select
                            v-model="register.ServicePerMonth"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsBajajServicePerMonth"
                            :selectOnTab=true
                          ></v-select>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Year Of Experience</label>
                          <v-select
                            v-model="register.YearOfExperience"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsYearOfExperience"
                            :selectOnTab=true
                          ></v-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-3">
                        <file-upload
                          :labelName="'Workshop /Offfice Photo'"
                          @imageUploadData="WorkShopImageData"
                        ></file-upload>
                      </div>
                      <div class="col-sm-1">
                        <div class="form-group" v-if="register.WorkshopPhotoUrl">
                        <a :href="register.WorkshopPhotoUrl" target="_blank">View photo</a>
                        </div>
                      </div>
                       <div class="col-sm-4">
                        <div class="form-group">
                          <label>Number of Engines Overhauled per month</label>
                          <input
                           
                            type="number"
                            class="form-control"
                            placeholder="Number of Engines Overhauled per month"
                            v-model="register.EnginesOverhauled"
                            name="EnginesOverhauled"
                          />
                        
                          
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>GST Number</label>

                          <input
                            v-model="register.GSTN"
                            v-validate="{ required: false, regex: /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/ }"
                            type="text"
                            class="form-control"
                            name="GSTN"
                          />
                          <span v-if="errors.has('GSTN')">
                            {{ errors.first('GSTN') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                  <div class="tab-pane" id="bankTab">
                    <div class="col-md-8">
                      <div class="row">
                      <div class="form-group">
                       <div class="col-sm-4">
                          <label>Account Holder Name *</label>
                        </div>
                      <div class="col-sm-8">
                          <input
                            v-model="register.BankHolderName"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="BankHolderName"
                          />
                          <span v-if="errors.has('BankHolderName')">
                            {{ errors.first('BankHolderName') }}
                          </span>
                       </div>
                    </div>
                    </div>
                   
                     <div class="row">
                        <div class="form-group">
                       <div class="col-sm-4">
                          <label>IFSC Code *</label>
                       </div>
                      <div class="col-sm-6">
                          <input
                            v-model="register.BankIFSCCode"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="BankIFSCCode"
                            data-vv-as="Bank IFSC Code"
                          />
                          <span v-if="errors.has('BankIFSCCode')">
                            {{ errors.first('BankIFSCCode') }}
                          </span>
                       </div>
                       <div class="col-sm-2"><button type="button" v-on:click="IFSCSearch" class="btn btn-primary">Search <i class="fa fa-search"></i></button></div>
                    </div>
                    </div>

                     <div class="row">
                        <div class="form-group">
                       <div class="col-sm-4">
                          <label>Account Number *</label>
                       </div>
                      <div class="col-sm-8">
                          <input
                            v-model="register.BankAccountNumber"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="BankAccountNumber"
                            data-vv-as="Bank Account Number"
                            ref="BankAccountNumber"
                          />
                          <span v-if="errors.has('BankAccountNumber')">
                            {{ errors.first('BankAccountNumber') }}
                          </span>
                       </div>
                      
                    </div>
                    </div>
                    <div class="row">
                        <div class="form-group">
                       <div class="col-sm-4">
                          <label>Conform Account Number *</label>
                       </div>
                      <div class="col-sm-8">
                          <input
                            v-model="register.ConformBankAccountNumber"
                            v-validate="'required|confirmed:BankAccountNumber'"
                            type="text"
                            class="form-control"
                            name="ConformBankAccountNumber"
                            data-vv-as="Conform Bank Account Number"
                          />
                          <span v-if="errors.has('ConformBankAccountNumber')">
                            {{ errors.first('ConformBankAccountNumber') }}
                          </span>
                       </div>
                      
                    </div>
                    </div>
                     <div class="row">
                       <div class="col-sm-4">
                          <div class="form-group">
                          <label>Bank Details Upload *</label>
                          </div>
                       </div>
                      <div class="col-sm-6">
                         <file-upload
                          :labelName="''"
                          @imageUploadData="BankDocImageData"
                        ></file-upload>
                       </div>
                       <div class="form-group">
                       <div class="col-sm-2" v-if="this.register.BankDocImageUrl"> <a :href="this.register.BankDocImageUrl" target="_blank">Bank Doc</a> </div>
                       </div>
                    </div>
                    </div>
                    <div class="col-md-4">
                      <br>
                      <br>
                      <br>
                      <br>
                      <br>
                      <div class="well">
                        <h4>Bank Search Details</h4>
                        <label> Name: </label> {{bank.BANK}} <br>
                        <label> Address:</label>  {{bank.ADDRESS}} <br>
                        <label> Branch Code:</label>  {{bank.BANKCODE}} <br>
                        <label> Branch :</label>  {{bank.BRANCH}} <br>
                        <label> State :</label>  {{bank.STATE}} <br>
                        <label> District :</label>  {{bank.DISTRICT}} <br>
                        <label> City :</label>  {{bank.CITY}} <br>
                        <label> MICR :</label>  {{bank.MICR}} <br>
                        <label> IFSC :</label>  {{bank.IFSC}} <br>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="termsConditions">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="tranms-text">
                          <p>Terms & Conditions</p>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="tranms-text">
                          <div class="checkbox1 checkbox-inline">
                            <label
                              ><input
                                type="checkbox"
                                v-model="termsAccept"
                                true-value="Accepted"
                                false-value="Not Accepted"
                                name="terms"
                              />
                              Terms & Conditions</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="checkbox checkbox-inline">
                          ----
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-3 col-sm-offset-9">
                        <div class="form-group">
                          <button
                            class="btn-raised btn-primary btn fixcolorAs"
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Submit</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div id="externalScript"></div>
  </div>
</template>
<script>
import UserService from '../../../services/user.service';
// import postscribe from 'postscribe';
import fileUpload from '../../components/file_upload';
// import searchSelect from '../../components/Select2Search';
import dobPicker from '../../components/date_picker';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
function bankInitialState(){
  return {
      BANK:'',
      ADDRESS:'',
      BANKCODE:'',
      BRANCH:'',
      CITY:'',
      DISTRICT:'',
      IFSC:'',
      MICR:'',
      STATE:''
    }
}
function initialState() {
  return {
    ShopName: '',
    MechanicId: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    AddressLine1: '',
    AddressLine2: '',
    Mobile: '',
    Mobile2: '',
    Email: '',
    Zip: '',
    Area: '',

    ProfilePicture: '',
    ProfilePictureUrl:'',
    selectedCity: '',
    State: '',
    Country: '',
    AadharCardNo: '',
    DrivingLicenseNo: '',
    PANNo: '',
    Gender: '',
    DateOfBirth: '',
    SizeOfWorkshop: null,
    // NoOfVehicleRepairPerMonth: null,
    ServicePerMonth: null,
    YearOfExperience: null,
    WorkshopPhoto: '',
    WorkshopPhotoUrl:'',

    retailer: [],
    dealer: [],
    EnginesOverhauled:'',
    BankHolderName:'',
    BankIFSCCode:'',
    BankAccountNumber:'',
    ConformBankAccountNumber:'',
    BankDocImage:'',
    BankDocImageUrl:'',
    BankName:'',
    BankMICR:'',
    GSTN:''
  };
}
export default {
  name: 'editReborer',
  data() {
    return {
      allGrinderReborerMenuActive:false,
      BreadcrumbItems: [
        { text: 'Home' },
        { text: 'All Users' },
        { text: 'Add User', active: true },
      ],
      DOBOptions: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
      },

      selectedCity: null,
      optionsMarketSegment: [
        { value: null, text: 'Please select Type' },
        { value: 'Agriculture', text: 'Agriculture' },
        { value: 'Industrial', text: 'Industrial' },
        { value: 'LCV', text: 'LCV' },
        { value: 'M/HCV', text: 'M/HCV' },
        { value: 'Micro-LCV', text: 'Micro-LCV' },
        { value: 'PC Diesel', text: 'PC Diesel' },
        { value: 'PC Gasoline', text: 'PC Gasoline' },
        { value: 'Tractor', text: 'Tractor' },
      ],
      optionsSizeOfWorkshop: [
        { value: null, text: 'Please select Size' },
        { value: '100', text: 'Upto 100 Sqft' },
        { value: '100-200', text: '100-200 Sqft' },
        { value: '200-300', text: '200-300 Sqft' },
        { value: '300+', text: 'More than 300 Sqft' },
      ],

      optionsBajajServicePerMonth: [
        { value: null, text: 'Please select Vehicle Service' },
        { value: '100', text: 'Upto < 100' },
        { value: '101-300', text: '100-300' },
        { value: '301-500', text: '300-500' },
        { value: '501+', text: '500' },
      ],
      GenderOptions: [
        { item: 'male', name: 'Male' },
        { item: 'female', name: 'FeMale' },
      ],
      optionsYearOfExperience: [
        { value: null, text: 'Please select Vehicle Service' },
        { value: 1, text: '1 Year' },
        { value: 2, text: '2 Year' },
        { value: 3, text: '3 Year' },
        { value: 4, text: '4 Year' },
        { value: 5, text: '5 Year' },
        { value: 6, text: '6 Year' },
        { value: 7, text: '7 Year' },
        { value: 8, text: '8 Year' },
        { value: 9, text: '9 Year' },
        { value: 10, text: '10 Year' },
      ],
      selectedCustomerSegment: null,
      termsAccept: 'Not Accepted',
      loading: false,
      message: '',
      register: initialState(),
      bank:bankInitialState(),
    };
  },
  components: {
    fileUpload,

    vSelect,
    dobPicker,
  },

  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    IFSCSearch(){
      let loader = this.$loading.show();
      var param = {};
      param.BankIFSCCode = this.register.BankIFSCCode
      UserService.getMetod('kspgAPI/user/bankSearch', param).then(
        (response) => {
          if(response.data.status){
            this.bank = response.data.bank;
            this.register.BankName = response.data.bank.BANK
            this.register.BankMICR = response.data.bank.MICR
          }
          // alert(response.data.models);
          // vm.results = response.data.models
          // const { register } = response.data.status;
          // this.register = register;
        },
        (error) => {
          Object.assign(this.$data.bank, bankInitialState());
          this.loading = false;

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      )
      setTimeout(() => {loader.hide()}, 1000)
    },
    getCityState() {
      if (this.register.Zip.length > 5) {
        let loader = this.$loading.show();
        /*Call API Get City And State*/
        var param = {};
        param.zip = this.register.Zip;
        UserService.getMetod('bajajAPI/CommonData/zipToAddress', param).then(
          (response) => {
            this.register.selectedCity = '';
            this.register.State = '';
            this.register.Country = '';
            // this.message = response.data.message;
            // this.loading = false;
            // // on success reset values
            if (response.data.country) {
              this.register.Country = response.data.country;
            }
            if (response.data.city) {
              this.register.selectedCity = response.data.city;
            }
            if (response.data.state) {
              this.register.State = response.data.state;
            }
          },
          (error) => {
            this.loading = false;

            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
        setTimeout(() => {loader.hide()}, 1000)
      }
    },
    ProfileImageData(imageData) {
      // console.warn(imageData.path);
      // console.warn(imageData.url)
      this.register.ProfilePicture = imageData.path;
      this.register.ProfilePictureUrl = imageData.url
      
      this.message = 'Picture Upload Successfully';
    },
    WorkShopImageData(imageData) {
      this.register.WorkshopPhoto = imageData.path;
      this.register.WorkshopPhotoUrl = imageData.url
      this.message = 'WorkShop Photo Upload Successfully';
    },
    BankDocImageData(imageData) {
      this.register.BankDocImage = imageData.path;
      this.register.BankDocImageUrl = imageData.url
      this.message = 'Passbook / Checkbook Photo Upload Successfully';
    },
    DOBSelected(dobdate) {
      this.register.DateOfBirth = dobdate;
    },
    getPrefilledData() {
      this.skyloStart();
      let loader = this.$loading.show();
      /*get  Partner Data */
      let param = {};
      param.partner_id = this.$route.params.partner_id;
      UserService.getMetod('kspgAPI/ReborerPlusGrinder/detail', param).then(
        (response) => {
          // alert(response.data.models);
          // vm.results = response.data.models
          const { register } = response.data;
          this.register = register;
          this.IFSCSearch();
        },
        (error) => {
          this.loading = false;

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 1000)
    },

    handleAddUser() {
      this.$validator.validateAll().then((res) => {
        if (this.termsAccept != 'Accepted') {
          this.message = 'Please accept Agreement';
          setTimeout(() => (this.message = false), 5000);
          return true;
        }

        if (this.register.ProfilePicture == '') {
          this.errors.add({
            field: 'photoProfile',
            msg: 'Please Upload Photo',
          });
          res = false;
        }
        if (!res) {
          // handle input errors.
          this.message = 'Please Fill all menditory Options';
          setTimeout(() => (this.message = false), 5000);
          return;
        }
        /*bajajAPI/user/add_mechanics*/
        let loader = this.$loading.show();
        UserService.postMetod(
          'kspgAPI/ReborerPlusGrinder/updateReborerPlusGrinder',
          this.register
        ).then(
          (response) => {
            this.message = response.data.message;
            this.loading = false;
          },
          (error) => {
            this.loading = false;

            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
        setTimeout(() => {loader.hide()}, 1000)
      });
      // Hide Messages
      setTimeout(() => (this.message = false), 5000);
    },
  },
  created() {
    this.getPrefilledData();
  },
  mounted() {
     this.menuList = this.$store.state.common.globalmenues
     this.menuList.forEach(element => {
      if(element.url === '/allGrinderReborer'){
        this.allGrinderReborerMenuActive =true
      }            
    });
  },
};
</script>
<style scoped>
.tab-container {
  font-size: small;
}
.radio1 > label {
  padding: 10px;
}
.btn-primary {
  color: cyan;
}

.visibility {
  visibility: visible !important;
}
</style>
